module.exports = __webpack_public_path__ + "static/media/13.c874b37b.jpg";